type ScreenShareUser = {
  id: string;
  self: boolean;
};

export type ScreenShareAudioMuteState = "by-user" | boolean;

export function getScreenShareAudioMuteState(
  user: ScreenShareUser | undefined,
  trackMuted: boolean,
  getScreenShareMuted: (userId: string) => boolean,
): ScreenShareAudioMuteState {
  return user && !user.self && getScreenShareMuted(user.id)
    ? "by-user"
    : trackMuted;
}
